export default "__VITE_ASSET__B3ac$60K__"